import { Button } from '../ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { ChevronLeftIcon, ChevronRightIcon, ChevronsLeftIcon, ChevronsRightIcon } from 'lucide-react';

export const PaginationControls = ({ pagination, totalItems, itemType = 'items', requiredRowsPerPage = true }) => {
    const { currentPage, totalPages, goToFirstPage, goToLastPage, goToPreviousPage, goToNextPage, changePageSize, itemsPerPage } =
        pagination;

    return (
        <div className="flex items-center justify-between gap-2 px-4 py-3">
            <div className="flex items-center gap-4">
                <strong className="text-sm text-neutral-500">
                    {totalItems} {itemType}
                </strong>
            </div>

            <div className="flex max-md:flex-col items-center gap-2">
                {requiredRowsPerPage && changePageSize && itemsPerPage && (
                    <div className="flex items-center gap-2 max-md:gap-0.5 max-md:hidden">
                        <strong className="text-sm text-neutral-500">Rows per page:</strong>
                        <Select value={itemsPerPage.toString()} onValueChange={value => changePageSize(Number(value))}>
                            <SelectTrigger className="w-20 h-8">
                                <SelectValue />
                            </SelectTrigger>
                            <SelectContent>
                                <SelectItem value="5">5</SelectItem>
                                <SelectItem value="10">10</SelectItem>
                                <SelectItem value="25">25</SelectItem>
                                <SelectItem value="50">50</SelectItem>
                                <SelectItem value="100">100</SelectItem>
                            </SelectContent>
                        </Select>
                    </div>
                )}
                <strong className="text-sm text-neutral-700">
                    Page {currentPage} of {totalPages}
                </strong>
                <div className="flex items-center gap-1">
                    <Button
                        variant="default"
                        size="icon"
                        className="h-8 w-8 hover:cursor-pointer shadow-none text-neutral-700"
                        onClick={goToFirstPage}
                        disabled={currentPage === 1}
                    >
                        <ChevronsLeftIcon className="h-4 w-4" />
                    </Button>
                    <Button
                        variant="default"
                        size="icon"
                        className="h-8 w-8 hover:cursor-pointer shadow-none text-neutral-700"
                        onClick={goToPreviousPage}
                        disabled={currentPage === 1}
                    >
                        <ChevronLeftIcon className="h-4 w-4" />
                    </Button>
                    <Button
                        variant="default"
                        size="icon"
                        className="h-8 w-8 hover:cursor-pointer shadow-none text-neutral-700"
                        onClick={goToNextPage}
                        disabled={currentPage === totalPages}
                    >
                        <ChevronRightIcon className="h-4 w-4" />
                    </Button>
                    <Button
                        variant="default"
                        size="icon"
                        className="h-8 w-8 hover:cursor-pointer shadow-none text-neutral-700"
                        onClick={goToLastPage}
                        disabled={currentPage === totalPages}
                    >
                        <ChevronsRightIcon className="h-4 w-4" />
                    </Button>
                </div>
            </div>
        </div>
    );
};
